import { createRouter, createWebHashHistory } from 'vue-router'
import DashboardView from '../views/DashboardView.vue'

// Set this to true to bypass authentication (for testing)
// Set to false in production to require real authentication
const isTestMode = true;

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: DashboardView,
    meta: { requiresAuth: true }
  },
  {
    path: '/markets',
    name: 'markets',
    component: () => import('../views/MarketsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/trade/:symbol?',
    name: 'trade',
    component: () => import('../views/TradeView.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import('../views/WalletView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/RegisterView.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('../views/ForgotPasswordView.vue'),
    meta: { requiresAuth: false }
  },
  {
    // 404 page
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// Navigation guard for authentication
router.beforeEach((to, from, next) => {
  // If test mode is enabled, skip all authentication checks
  if (isTestMode) {
    // Set a dummy token to make isAuthenticated return true
    if (!localStorage.getItem('auth_token')) {
      localStorage.setItem('auth_token', 'test_token');
    }
    return next();
  }
  
  const isAuthenticated = localStorage.getItem('auth_token') // Simple auth check
  
  if (to.meta.requiresAuth && !isAuthenticated) {
    // Redirect to login if trying to access protected route
    next({ name: 'login' })
  } else if (!to.meta.requiresAuth && isAuthenticated && 
             (to.name === 'login' || to.name === 'register' || to.name === 'forgot-password')) {
    // Redirect to dashboard if trying to access auth pages while logged in
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

export default router
